import { Market } from '@org-avp/models';
import { Locale } from '@org-avp/avp-hck-dga-customerui-commons';
import { MarketWebsites } from '../marketUtils';

export const vwnMarketSites: Partial<Record<Market, Array<MarketWebsites>>> = {
  [Market.DEU]: [
    {
      locale: Locale.de_DE,
      configurator: 'https://www.volkswagen-nutzfahrzeuge.de/de/konfigurator.html',
      testdrive: 'https://www.volkswagen-nutzfahrzeuge.de/de/formulare/probefahrtanfrage.html',
    },
  ],
  [Market.IRL]: [
    {
      locale: Locale.en_IE,
      configurator: 'https://www.volkswagenvans.ie/en/configurator.html',
      testdrive: 'https://www.volkswagenvans.ie/en/forms/testdrive.html',
    },
  ],
  [Market.ITA]: [
    {
      locale: Locale.it_IT,
      configurator: 'https://www.volkswagen-veicolicommerciali.it/it/configura-il-tuo-veicolo.html',
      testdrive: 'https://www.volkswagen-veicolicommerciali.it/it/forms/test-drive.html',
    },
  ],
  [Market.ESP]: [
    {
      locale: Locale.es_ES,
      configurator: 'https://www.volkswagen-comerciales.es/es/configurador.html',
      testdrive: 'https://www.volkswagen-comerciales.es/formularios/test-drive',
    },
  ],
  [Market.CHE]: [
    {
      locale: Locale.de_CH,
      configurator: 'https://www.volkswagen-nutzfahrzeuge.ch/de/konfigurator.html',
      testdrive: 'https://www.volkswagen-nutzfahrzeuge.ch/de/formulare/probefahrtanfrage.html',
    },
    {
      locale: Locale.it_CH,
      configurator: 'https://www.volkswagen-nutzfahrzeuge.ch/it/configuratore.html',
      testdrive: 'https://www.volkswagen-nutzfahrzeuge.ch/it/moduli/prova-di-guida.html',
    },
    {
      locale: Locale.fr_CH,
      configurator: 'https://www.volkswagen-nutzfahrzeuge.ch/fr/configurateur.html',
      testdrive: 'https://www.volkswagen-nutzfahrzeuge.ch/fr/formulaires/essai-routier.html',
    },
  ],
  [Market.POL]: [
    {
      locale: Locale.pl_PL,
      configurator: 'https://www.vwdostawcze.pl/pl/konfigurator.html/',
      testdrive: 'https://www.vwdostawcze.pl/pl/formularze/jazda-probna.html',
    },
  ],
  [Market.SWE]: [
    {
      locale: Locale.sv_SE,
      configurator: 'https://www.volkswagen-transportbilar.se/sv/bygg-din-bil.html',
      testdrive: 'https://www.volkswagen-transportbilar.se/sv/intresse/provkorning.html',
    },
  ],
  [Market.NLD]: [
    {
      locale: Locale.nl_NL,
      configurator: 'https://www.vwbedrijfswagens.nl/nl/configurator.html',
      testdrive: 'https://www.vwbedrijfswagens.nl/nl/formulieren/proefrit-plannen.html',
    },
  ],
  [Market.LUX]: [
    {
      locale: Locale.fr_LU,
      configurator: 'https://www.volkswagen-utilitaires.lu/fr/configurateur.html',
      testdrive: 'https://www.volkswagen-utilitaires.lu/fr/formulaires/essai-routier.html',
    },
  ],
  [Market.NOR]: [
    {
      locale: Locale.no_NO,
      configurator: 'https://www.volkswagen.no/no/bygg-din-volkswagen.html',
      testdrive: 'https://www.volkswagen.no/no/skjemaer/provekjore.html',
    },
  ],
  [Market.GBR]: [
    {
      locale: Locale.en_GB,
      configurator: 'https://www.volkswagen-vans.co.uk/en/configurator.html',
      testdrive: 'https://www.volkswagen-vans.co.uk/en/forms/testdrive.html',
    },
  ],
  [Market.NZL]: [
    {
      locale: Locale.en_NZ,
      testdrive: 'https://www.volkswagen.co.nz/app/nz/test-drive',
    },
  ],
  [Market.ZAF]: [
    {
      locale: Locale.en_ZA,
      configurator: 'https://www.vw.co.za/en/configurator.html',
      testdrive: 'https://www.vw.co.za/en/forms/testdrive.html',
    },
  ],
};
